import {autoloadBlocks, autoloadPlugins} from '@lipemat/js-boilerplate-gutenberg';

/**
 * Use our custom autoloader to automatically require,
 * register and add HMR support to Gutenberg-related items.
 *
 * Will load from a specified directory recursively.
 */
export default () => {
	// Load all block plugins
	autoloadPlugins( () => require.context( './blocks', false, /plugin\.tsx$/ ), module );
	// Load all blocks
	autoloadBlocks( () => require.context( './blocks', true, /block\.tsx$/ ), module );
	// Load all standard plugins
	autoloadPlugins( () => require.context( './plugins', true, /plugin\.tsx$/ ), module );
	// Customizer screen does not have a `PluginArea`.
	// @ts-ignore
	if ( typeof window.wp.customize !== 'undefined' ) {
		require( './blocks/plugin' ).settings.render();
	}
}
